import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "MA_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#MA_svg__a)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M0 0h32v22a2 2 0 01-2 2H2a2 2 0 01-2-2V0z", fill: "#C51918" }), /* @__PURE__ */ e.createElement("path", { d: "M0 0h32v24H0V0z", fill: "#E31D1C" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22.482 19.626L16.166 2.7h-.274L9.794 19.626l6.331-3.805 6.356 3.805zM15.467 8.22l.677-2.638.702 2.714 2.019 5.656 1.185 2.739-2.559-1.803-1.366-.818-1.344.808-2.5 1.813 1.156-2.795 2.03-5.676z",
      fill: "#579D20"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.662 13.473l3.496 2.324 3.262-2.324 6.196-5.237H6.385l6.277 5.237zm.073-2l-2.378-1.454h11.224L19.54 11.31l-3.397 2.577-3.408-2.415z",
      fill: "#579D20"
    }
  ))
), a = t;
export {
  a as default
};
